const gift_list = {
  title: '交換商品管理',
  new: '追加',
  id: '順番',
  name: '交換商品名',
  gift_type: '商品種類',
  start_date: '開始日',
  end_date: '終了日',
  point_exchange: '交換ポイント数',
  participants: '受講生',
  student_coach: 'コーチ',
  limit: '商品上限',
  search_gift_placeholder: '商品名、商品種類など入力',
  status_public: '公開',
  status_draft: '上書き',
  quantity_unlimited: '無限',
  modal: {
    change_status_draft_to_public: {
      title: '商品公開の確認',
      content: 'ご指定の商品を公開すると、アプリ上で表示されます。よろしいでしょうか。',
      cancel: 'いいえ',
      yes: 'はい',
    },
    change_status_public_to_draft: {
      title: '商品非公開の確認',
      content: 'ご指定の商品を非公開すると、アプリ上で表示されません。よろしいでしょうか。',
      cancel: ' いいえ',
      yes: 'はい',
    },
    delete: {
      title: '商品削除',
      content: 'ご指定の商品を削除します。よろしいでしょうか。',
      cancel: 'いいえ',
      delete: 'はい',
    }
  },
  toast: {
    public_gift_success: 'ご指定の商品を公開しました。',
    save_draft_gift_success: 'ご指定の商品を非公開しました。',
    delete_gift_success: 'ご指定の商品を削除しました。',
    gift_data_required: '商品の必須情報が十分に登録されていないため、商品を公開できません。再度商品詳細をご確認ください。',
  }
};

export default gift_list;
